import { ChangeEvent, useState } from "react";

// Допустил, что значения полей могут быть string | number
export function useForm<T extends Record<string, string | number>>(inputValues: T) {
    const [values, setValues] = useState(inputValues);
  
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      const {value, name} = event.target;
      setValues({...values, [name]: value});
    };
    return {values, handleChange, setValues};
  }